// extracted by mini-css-extract-plugin
module.exports = {"error-label":"FormError_error-label__XbrJz","error":"FormError_error__36zZb"};